import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { captureExploreToken } from './Common/ExploreAttribution';
global.Intl = require('intl');
captureExploreToken();
ReactDOM.render(<App/>, document.getElementById('root'));

unregister()
